import React from "react"

const SectionTitle: React.FC<React.PropsWithChildren> = ({children: Title}) => {
  return <h2 className="neo__sectionTitle"><span><span>{Title}</span></span></h2>
}

export default SectionTitle
